import { SITE_COMPONENTS_SDK_STATICS_FOLDER } from '@wix/cli-app-definitions';
import { mergeConfig } from 'vite';
import type { InlineConfig } from 'vite';
import type { ProjectModel } from '../../../model.js';
import type { ViteBuildConfigOptions } from '../../vite-config-options.js';
import { virtualSiteComponentSdkScriptAssets } from '../../../dev-center/components/site/config.js';
import { moduleBundleBuildSiteComponents } from '../../plugins/module-bundle/plugin.js';
import { getBaseViteConfig } from './base.js';

export function getViteConfig(
  model: ProjectModel,
  options: ViteBuildConfigOptions
): InlineConfig[] {
  const virtualSiteComponentSdkScriptEntries = [
    ...virtualSiteComponentSdkScriptAssets(model),
  ].map(
    ([assetId, component]) =>
      [`script-asset-${component.id}-sdk`, assetId] as const
  );

  return virtualSiteComponentSdkScriptEntries.map(([entryName, entryPath]) => {
    const baseConfig = getBaseViteConfig({
      ...options,
      model,
      outputDir: SITE_COMPONENTS_SDK_STATICS_FOLDER,
    });

    const config = {
      ssr: {
        target: 'webworker',
        noExternal: true,
      },
      build: {
        ssr: true,
        rollupOptions: {
          input: {
            [entryName]: entryPath,
          },
          output: {
            inlineDynamicImports: true,
          },
        },
      },
      plugins: [moduleBundleBuildSiteComponents({ initialModel: model })],
    } satisfies InlineConfig;

    return mergeConfig(config, baseConfig);
  });
}
